var map = {
	"vs/editor/common/services/editorSimpleWorker": 61
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 272;


//////////////////
// WEBPACK FOOTER
// ./submodules/vscode/src/vs/base/common/worker
// module id = 272
// module chunks = 0